if (!customElements.get('jewel-initial-ring-preview')) {
  customElements.define(
    'jewel-initial-ring-preview',
    class extends HTMLElement {
      connectedCallback() {
        this.stone = this.querySelector('.jewel-initial-ring-preview__stone');
        this.letter = this.querySelector('.jewel-initial-ring-preview__letter');
        this.months = Object.keys(this.stonePositions);
        this.currentMonth = this.normalizeMonth(this.dataset.initialMonth) || 'january';
        this.currentLetter = this.normalizeLetter(this.dataset.initialLetter) || 'A';
        this.currentIndex = Math.max(0, this.months.indexOf(this.currentMonth));
        this.birthstoneSelected = false;
        this.interval = null;
        this.abortController = new AbortController();

        document.addEventListener('jewel:birthstones-preview', this.handleBirthstoneSelection, {
          signal: this.abortController.signal,
        });
        document.addEventListener('jewel:birthstones-change', this.handleBirthstoneSelection, {
          signal: this.abortController.signal,
        });
        document.addEventListener('jewel:initial-change', this.handleInitialSelection, {
          signal: this.abortController.signal,
        });

        this.updateStone(this.currentMonth);
        this.updateLetter(this.currentLetter);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.stopAutoplay();
      }

      stonePositions = {
        january: ['8%', '12.5%'],
        february: ['36.2%', '12.5%'],
        march: ['64.1%', '12.5%'],
        april: ['92.1%', '12.5%'],
        may: ['8%', '45.4%'],
        june: ['36.2%', '45.4%'],
        july: ['64.1%', '45.4%'],
        august: ['92.1%', '45.4%'],
        september: ['8%', '78.3%'],
        october: ['36.2%', '78.3%'],
        november: ['64.1%', '78.3%'],
        december: ['92.1%', '78.3%'],
      };

      normalizeMonth(value) {
        return String(value || '').trim().toLowerCase();
      }

      normalizeLetter(value) {
        const letter = String(value || '').trim().toUpperCase();
        return /^[A-Z]$/.test(letter) ? letter : '';
      }

      handleBirthstoneSelection = (event) => {
        if (event.detail?.formId !== this.dataset.formId) return;
        const month = this.normalizeMonth(event.detail?.one);
        if (!this.stonePositions[month]) return;
        this.birthstoneSelected = true;
        this.stopAutoplay();
        this.updateStone(month);
      };

      handleInitialSelection = (event) => {
        if (event.detail?.formId !== this.dataset.formId) return;
        const letter = this.normalizeLetter(event.detail?.letter);
        if (!letter) return;
        this.updateLetter(letter);
      };

      startAutoplay() {
        if (
          this.birthstoneSelected
          || this.months.length < 2
          || window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) return;

        const speed = Math.max(1200, Number(this.dataset.autoplaySpeed) || 1800);
        this.interval = window.setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.months.length;
          this.updateStone(this.months[this.currentIndex]);
        }, speed);
      }

      stopAutoplay() {
        window.clearInterval(this.interval);
        this.interval = null;
      }

      updateStone(month) {
        const position = this.stonePositions[month];
        if (!position || !this.stone) return;
        this.stone.style.setProperty('--jirp-stone-x', position[0]);
        this.stone.style.setProperty('--jirp-stone-y', position[1]);
        this.currentMonth = month;
        this.currentIndex = Math.max(0, this.months.indexOf(month));
        this.updateLabel();
      }

      updateLetter(letter) {
        if (!this.letter) return;
        const index = letter.charCodeAt(0) - 65;
        const column = index % 7;
        const row = Math.floor(index / 7);
        const x = column === 6 ? 100 : (column / 6) * 100;
        const y = row === 3 ? 100 : (row / 3) * 100;
        this.letter.style.setProperty('--jirp-letter-x', `${x}%`);
        this.letter.style.setProperty('--jirp-letter-y', `${y}%`);
        this.currentLetter = letter;
        this.updateLabel();
      }

      updateLabel() {
        const finish = `${this.dataset.finish.charAt(0).toUpperCase()}${this.dataset.finish.slice(1)}`;
        const month = `${this.currentMonth.charAt(0).toUpperCase()}${this.currentMonth.slice(1)}`;
        this.setAttribute(
          'aria-label',
          `${finish} Monty Initial Birthstone Ring with letter ${this.currentLetter} and ${month} birthstone`
        );
      }
    }
  );
}
